import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonClose: {
    alignSelf: 'flex-end',
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    backgroundColor: 'rgba(215, 222, 233, 0.25)',
    '&:hover': {
      backgroundColor: 'rgba(215, 222, 233, 0.5)',
    },
  },
  iconClose: {
    width: '18px',
    height: '18px',
    color: '#4F4F4F',
  },
}));
